// extracted by mini-css-extract-plugin
module.exports = {"globalHeaderRight":"global-header-right_globalHeaderRight_JlFR2","iconLink":"global-header-right_iconLink_19mBn"};